module.exports = __webpack_public_path__ + "static/media/siddharth-bangalore-palace.b43e4bb9.jpg";